module.exports = __webpack_public_path__ + "static/media/ic_attendee.462b713c.svg";